
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import CustomerListItem from '@/models/Customer/CustomerListItem';
import { CUSTOMERS_FETCH, CUSTOMERS_NEW, CUSTOMERS_EDIT, CUSTOMERS_ACTIVE } from '../ActionTypes';
import { CUSTOMER_SET_FETCH_STATUS, CUSTOMER_SET_STATE } from '../MutationTypes';
import CustomersRepository from '@/utils/API/CustomersRepository';
import ListRequest from '@/models/ListRequest';
import CustomerNew from '@/models/Customer/CustomerNew';
import CustomerEdit from '@/models/Customer/CustomerEdit';
import { FetchStatus } from '../FetchStatusTypes';
import CustomerActive from '@/models/Customer/CustomerActive';


export interface CustomersState {
    totalCount: number;
    count: number;
    customerList: CustomerListItem[];
    errorMessage: string;
    fetchStatus: FetchStatus;
    page: number;
    pageSize: number;
}

const state: CustomersState = {
    totalCount: 0,
    count: 0,
    customerList: [],
    errorMessage: '',
    fetchStatus: FetchStatus.Idle,
    page: 1,
    pageSize: 25,
};

const actions: ActionTree<any, any> = {

    [CUSTOMERS_FETCH]({ commit }, listRequest: ListRequest) {

        return new Promise((resolve, reject) => {
            commit(CUSTOMER_SET_FETCH_STATUS, { fetchStatus: FetchStatus.Fetching, errorMessage: '' });
            CustomersRepository.fetchCustomersList(listRequest)
                .then((response: any) => {

                    commit(CUSTOMER_SET_FETCH_STATUS, { fetchStatus: FetchStatus.Success, errorMessage: '' });

                    // const cList = response.data.result.map((item: CustomerListItem) => {
                    //     const sub = item.currentSubscription;
                    //     const transformedSubscription = new Subscription(sub.id, sub.subscriptionPackageName, sub.subscriptionType, sub.subscriptionStatus, sub.from, ('to' in sub) ? sub.to : NA);
                    //     return new CustomerListItem(item.id, item.name, item.ownerEmail, item.ownerFirstName, item.ownerLastName, transformedSubscription, item.phone, item.creationMode, item.isDisabled);
                    // });

                    const cList = response.data.result;
                    cList.map((x: any) => {
                        return x;
                    });

                    // tslint:disable-next-line:max-line-length
                    commit(CUSTOMER_SET_STATE, { totalCount: response.data.totalCount, count: response.data.count, customerList: cList, page: listRequest.queryOptions.page, pageSize: listRequest.queryOptions.pageSize });
                    resolve(response);
                }).catch((err: any) => {
                    // tslint:disable-next-line:max-line-length
                    reject(err);
                    commit(CUSTOMER_SET_FETCH_STATUS, { fetchStatus: FetchStatus.Fail, errorMessage: err.toString() });
                });
        });
    },
    [CUSTOMERS_NEW]({ }, newCustomer: CustomerNew) {

        return new Promise((resolve, reject) => {
            CustomersRepository.newCustomer(newCustomer)
                .then((response: any) => {
                    resolve(response);
                }).catch((err: any) => {
                    reject(err);
                });
        });
    },
    [CUSTOMERS_EDIT]({ }, editCustomer: CustomerEdit) {

        return new Promise((resolve, reject) => {
            CustomersRepository.editCustomer(editCustomer)
                .then((response: any) => {
                    resolve(response);
                }).catch((err: any) => {
                    reject(err);
                });
        });
    },
    [CUSTOMERS_ACTIVE]({ }, customerActive: CustomerActive) {

        return new Promise((resolve, reject) => {
            CustomersRepository.activeCustomer(customerActive)
                .then((response: any) => {
                    resolve(response);
                }).catch((err: any) => {
                    reject(err);
                });
        });
    },
};

const mutations: MutationTree<CustomersState> = {
    // tslint:disable-next-line:max-line-length
    [CUSTOMER_SET_FETCH_STATUS](state, { fetchStatus, errorMessage }: { fetchStatus: FetchStatus, errorMessage: string }) {
        state.fetchStatus = fetchStatus;
        state.errorMessage = errorMessage;
    },
    [CUSTOMER_SET_STATE](state, { totalCount, count, customerList, page, pageSize }: { totalCount: number, count: number, customerList: CustomerListItem[], page: number, pageSize: number }) {
        state.totalCount = totalCount;
        state.count = count;
        state.customerList = customerList;
        state.page = page;
        state.pageSize = pageSize;
    },
};

const getters: GetterTree<CustomersState, any> = {
};

export const CustomersModule = {
    state,
    actions,
    getters,
    mutations,
};
